module.exports = __webpack_public_path__ + "static/media/arrow-next.ab890066.svg";